import { useContext } from 'react'

import type { WorkspacesContextValue } from '@/components/dashboard/layout/workspaces/workspaces-context'
import { WorkspacesContext } from '@/components/dashboard/layout/workspaces/workspaces-context'

export function useWorkspaces(): WorkspacesContextValue {
	const context = useContext(WorkspacesContext)

	if (!context) {
		throw new Error('useWorkspaces must be used within a WorkspacesProvider')
	}

	return context
}
